import axios from "axios";
import { EquipmentHighlight } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_equipment_highlights", async () =>
		(await axios.get<EquipmentHighlight[]>(`/api/vehicles/equipment-highlights`)).data
	);
